import {combineReducers} from 'redux';
import {loader} from './loader'
import {
    signIn,
    registration, 
    signinStatus, 
    registrationStatus,
    resetPassword,
    validateToken,
    changePassword,
    validateMemberAccount,
    hasActivatedEmail
} from './authReducer'
import {provinces, districts, sectors, villages, cells} from  './locations'
import {events} from './events'
import {membershipGrade} from './membershipGrade'
import {awardTypes} from './awardTypes'
import {displine} from './discipline'
import {paymentReport} from './paymentReport'
import {
    individualApplication,
    hasUpdatedIndividualApplication,
    individualApplicationReport,
    submittedApplication,
    hasDeletedApplication,
    validateMembership,
    fetchClassDetails,
    fetchClassNotesDetails,
    fetchCountries
} from './individualApplication'
import {hasPaid,paymentStatus, generatedBillId} from './pay'
import {
    firmApplication,
    firmApplicationSubmitted,
    updatedFirmApplication,
    hasUpdatedFirm
} from './firmApplication'
import {userApplications} from './applicationStatus'
import {applicationTypes} from './applicationTypes'
import {fetchFile} from './downloadFile'
import {membership,
    hasEditedMembership
} from './membership'

import {certificates}
from './certificate'

import {
    userBillers,
    billDetails
}
from './billers'

const rootReducer = combineReducers({
    loader,
    signIn,
    provinces,
    districts,
    sectors,
    cells,
    villages,
    events,
    membershipGrade,
    registration,
    awardTypes,
    displine,
    paymentReport,
    individualApplication,
    hasPaid,
    signinStatus,
    hasUpdatedIndividualApplication,
    registrationStatus,
    paymentStatus,
    firmApplication,
    userApplications,
    individualApplicationReport,
    applicationTypes,
    submittedApplication,
    generatedBillId,
    fetchFile,
    firmApplicationSubmitted,
    updatedFirmApplication,
    hasUpdatedFirm,
    hasDeletedApplication,
    resetPassword,
    membership,
    hasEditedMembership,
    certificates,
    validateMembership,
    userBillers,
    billDetails,
    fetchClassDetails,
    fetchClassNotesDetails,
    validateToken,
    changePassword,
    validateMemberAccount,
    fetchCountries,
    hasActivatedEmail
})

export default rootReducer